import React, { useEffect, useState } from "react";
import { StatusIcon } from "../../assets/svg/StatusIcon";
import styled, { keyframes } from "styled-components";
import { NavLink, useRouteMatch } from "react-router-dom";
import { get } from "../../utils/get";
import { SCORECARD_URL } from "../../api/urls";
import { GetHook } from "../../api/api";
import { KPISubject } from "../../subjects/KPISubject";
import moment from "moment";

interface IProps {
  lastLocationO: string | undefined;
  scorecardId: string;
  objectiveId: string;
  perspectiveId: string;
}
export const KPIAccordion = ({
  lastLocationO,
  scorecardId,
  objectiveId,
  perspectiveId,
}: IProps) => {
  const [score, setScore] = useState<any>();
  const { url } = useRouteMatch();

  const date = `${moment().startOf("year").format("YYYY-MM-DD")}/${moment().format("YYYY-MM-DD")}`;

  let { data } = GetHook(
    `${SCORECARD_URL}/${scorecardId}/kpi?&objective_id=${objectiveId}`
  );

  useEffect(() => {
    const subscription = KPISubject.subscribe((payload) => {
      setScore(payload);
    });
    return () => subscription.unsubscribe();
  }, []);

  const getColor = (score) => {
    switch (true) {
      case score >= 1 && score < 2:
        return "#D51067";
      case score >= 2 && score <= 3:
        return "#EDBC0C";
      case score > 3:
        return "#4BD041";
      case score >= 5:
        return "url(#grad2)";
      default:
        return "#D51067";
    }
  };

  return (
    <KPIContainer>
      {Array.isArray(data) &&
        data.length >= 1 &&
        data.map((kpi: any, index: number) => (
          <React.Fragment key={kpi.kpi_id}>
            {index > 0 && <Devider />}
            <ListItem
              onClick={() => KPISubject.next(kpi)}
              to={{
                pathname: `${url}/${scorecardId}/perspective/${perspectiveId}/objective/${objectiveId}/kpi/${get(
                  kpi,
                  "kpi_id"
                )}/${lastLocationO}`,
                state: { lastLocationO },
              }}
            >
              <StatusIconWrapper>
                <StatusIcon
                  color={
                    kpi.id === get(score, "[0].id")
                      ? getColor(get(score, "[0].periodic_score"))
                      : getColor(get(kpi, "periodic_score"))
                  }
                />
              </StatusIconWrapper>
              <KPIName>{get(kpi, "kpi_name")}</KPIName>
            </ListItem>
          </React.Fragment>
        ))}
    </KPIContainer>
  );
};

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
`;

const ListItem = styled(NavLink)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0.8em 1em;
  text-decoration: none;
  border-radius: 0.5em;
  background-color: #fff;
  font-weight: 450;
  color: #214160;
  font-size: 13px;
  margin-top: 0.8em;
  width: 200px;
  transition: all 0.3s ease;
  animation: ${fadeIn} 0.3s ease-out;

  &:hover {
    background-color: #f5f7ff;
  }

  &.active {
    background-color: #01A8CE;
    color: #fff;
    margin-left: 1em;
    font-weight: 500;
  }
`;

const Devider = styled.div`
  border-left: 1px dotted rgba(55, 81, 255, 0.2);
  border-bottom: 1px dotted rgba(55, 81, 255, 0.2);
  margin-left: 1em;
  margin-bottom: 0.5em;
  height: 1.2em;
`;

const StatusIconWrapper = styled.span`
  padding-right: 1em;
  display: flex;
  align-items: center;
`;

const KPIName = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const KPIContainer = styled.div`
  animation: ${fadeIn} 0.5s ease-out;
`;
